import React from 'react';
import styles from './style.module.scss';
import cx from 'classnames';
import Tooltip from "src/components/tooltip";

import { localizedStrings } from 'src/localization';

class LockIcon extends React.Component {
  constructor(props){
    super(props);

    this.entering =this.entering.bind(this);

    this.localizedCollection = localizedStrings.pages.collections.collection;

  }

  entering(e){

  };

  render(){
    let style = {
      width: this.props.size,
      height: this.props.size,
    }
    return (
      <Tooltip placement={this.props.direction ? this.props.direction : "left"} content={ this.localizedCollection.tooltips.internal_use_only }>
  <div className={cx(styles.icon, this.props.className) } style={style}>
        <div className={ styles.inner }>
         <i className='paperflite-lock' />
        </div>
      </div>
      </Tooltip>
     
    );
  } 
}

LockIcon.defaultProps = {size: 24}

export default LockIcon;